// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".6777a845a87381ac1324ffeb97a092feb5cd19ee.chunk.js";
};